import {
    PricingTableWithoutFetch,
    PricingTableWithoutFetchProps
} from "./pricing-table-without-fetch.tsx";

export type UniformPricingTableProps = PricingTableWithoutFetchProps;

const UniformPricingTable = (props: UniformPricingTableProps) => {
    // todo: GWP-11369 implement PricingTableWithFetch and render conditionally

    return <PricingTableWithoutFetch {...props} />;
};

export default UniformPricingTable;
